import React from "react";
import { DriverProvider, useDriver } from "./DriverContext";
import { PersonalInfoForm } from "./PersonalInfoForm";
import { VehicleInfoForm } from "./VehicleInfoForm";
import transparentBg from "../../../../assets/images/transparent-bg.png";

export const StepRenderer: React.FC<{
  onClose: () => void;
  driverType: string;
}> = ({ onClose, driverType }) => {
  const { state } = useDriver();

  React.useEffect(() => {
    if (state.currentStep === "") {
      onClose();
    }
  }, [state.currentStep, onClose]);

  const renderCurrentStep = () => {
    switch (state.currentStep) {
      case "personal":
        return <PersonalInfoForm driverType={driverType} />;
      case "vehicle":
        return <VehicleInfoForm />;
      default:
        return <PersonalInfoForm driverType={driverType} />;
    }
  };

  return (
    <div
      className=" bg-cover bg-center flex justify-center p-5 overflow-hidden overflow-y-auto min-h-screen"
      style={{
        backgroundImage: `url(${transparentBg})`,
      }}
    >
      {renderCurrentStep()}
    </div>
  );
};

const Driver: React.FC<{ onClose: () => void; driverType: string }> = ({
  onClose,
  driverType,
}) => {
  return (
    <DriverProvider>
      <StepRenderer onClose={onClose} driverType={driverType} />
    </DriverProvider>
  );
};

export default Driver;